import api from "~/services/api";
const CONTROLLER_NAME = "/me";

export const getMe = (config = {}) => {
	return api.get(`${CONTROLLER_NAME}`, config);
};

export default {
	getMe,
};